import { api } from "./core";

export const authApi = {
  register(payload) {
    return api("/api/auth/register", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  login(payload) {
    return api("/api/auth/login", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  me() {
    return api("/api/auth/me");
  },

  logout() {
    return api("/api/auth/logout", { method: "POST" });
  },
};
